import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import SelectCMOEventTypes from './SelectCMOEventTypes';
import CreateEventStepper from './eventStepper';
import { AddCircleOutline } from '@material-ui/icons';
import CustomButton from '../CusomButton';

const useStyles = makeStyles((theme) => ({
  qualityEventBtn: {
    width: '80%',

    backgroundImage: 'linear-gradient(to right, #301232, #1A2D6C,#173072)',
    color: 'white',
    border: '1px solid black',
    textTransform: 'none',
    borderRadius: '2rem',
    paddingLeft: '4px',
    marginLeft: '1rem',
    '&:hover': {
      backgroundColor: '#173072',
      color: 'white',
      border: '1px solid black',
    },
  },
  addIcon: {
    fontSize: '25px',
    color: 'white',
    marginLeft: '10px',
  },
}));

const CreateAnEvent = (props) => {
  const classes = useStyles();
  const { deliverablesData, exceptionData, workItemDetails,handleExceptionReload } = props
  const [state, setState] = useState({
    cmoEventTypesScreen: false,
    eventStepperScreen: false,
    qualityEvent: '',
  });

  const toggleDialog = (dialogName) => {
    if (dialogName === 'eventStepperScreen' && state.eventStepperScreen) {
      setState((prevState) => ({
        ...prevState,
        CMOMember: '',
        qualityEvent: '',
      }));
      handleExceptionReload();
    }
    setState((prevState) => ({
      ...prevState,
      [dialogName]: !state[dialogName],
    }));
  };

  const handleChangeData = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const openEventStepperScreen = () => {
    setState((prevState) => ({
      ...prevState,
      cmoEventTypesScreen: false,
      eventStepperScreen: true,
    }));
  };

 
  return (
    <>
      <div style={{ width: '12rem' }}>
      <CustomButton
              color="#F26336" // Custom orange background
              hoverColor="#D8542E" // Darker orange on hover
              textColor="#fff" // Explicitly set white text color
          startIcon={<AddCircleOutline />}
          onClick={() => toggleDialog('cmoEventTypesScreen')}
            >
             Add New Exception
            </CustomButton>
        {/* <Button
          startIcon={<AddCircleOutline />}
          // className={classes.qualityEventBtn}
          color="#F26336" // Custom orange background
              hoverColor="#D8542E" // Darker orange on hover
              textColor="#fff" // Explicitly set white text color
          onClick={() => toggleDialog('cmoEventTypesScreen')}
        >
          
        </Button> */}
      </div>

      {state.cmoEventTypesScreen && (
        <SelectCMOEventTypes
          openDialog={state.cmoEventTypesScreen}
          toggleDialog={toggleDialog}
          handleChangeData={handleChangeData}
          CMOMember={{
            organizationId: deliverablesData.cdmoOrgID,
            organizationName: deliverablesData.cdmoOrgName
          }}
          qualityEvent={state.qualityEvent}
          openEventStepperScreen={openEventStepperScreen}
          deliverablesData={deliverablesData}
        />
      )}

      {state.eventStepperScreen && (
        <CreateEventStepper
          openDialog={state.eventStepperScreen}
          toggleDialog={toggleDialog}
          CMOMember={{
            organizationId: deliverablesData.cdmoOrgID,
            organizationName: deliverablesData.cdmoOrgName
          }}
          qualityEvent={state.qualityEvent}
          exceptionData={deliverablesData}
          workItemDetails={workItemDetails}
        />
      )}
    </>
  );
};

export default CreateAnEvent;
